import { useSelector } from 'react-redux'
import RetinarLogo from '../../assets/images/lightblue_logo.png'
import UserOption from '../../components/UserOption'
import { SessionExpired } from '../../components/SessionExpired'
import VersionIndicator from '../../components/VersionIndicator'
import {
  HomeContainer,
  MainContent,
  LogoWrapper,
  Logo,
  Subtitle,
  CardsGrid,
  VersionWrapper,
  TechnicalContext,
  ContextIcon,
  ContextText
} from './styles'

function DashboardLayout({ title, admin, children }) {
  const { user } = useSelector(state => state)

  return (
    <HomeContainer>
      <MainContent>
        <SessionExpired />
        {user.role === 'technical' && (
          <TechnicalContext>
            <ContextIcon>📍</ContextIcon>
            <ContextText>
              {user.data?.nodoCaptura
                ? (
                  <><strong>{user.data.nodoCaptura.nombre}</strong> — {user.data.nodoCaptura.modeloRetinografo}</>
                  )
                : (
                  <><strong>Sin nodo asignado</strong> — Contacte al administrador</>
                  )}
            </ContextText>
          </TechnicalContext>
        )}
        <LogoWrapper>
          <Logo src={RetinarLogo} alt='logo' />
          <Subtitle>{title}</Subtitle>
        </LogoWrapper>
        <CardsGrid admin={admin}>
          {children}
        </CardsGrid>
        <VersionWrapper>
          <VersionIndicator />
        </VersionWrapper>
      </MainContent>
    </HomeContainer>
  )
}

export function Home() {
  const { user } = useSelector(state => state)

  if (user.role === 'technical') {
    return (
      <DashboardLayout title='Panel del Técnico'>
        <UserOption type='evaluations' />
        <UserOption type='new-patient' />
        <UserOption type='case' />
      </DashboardLayout>
    )
  }

  if (user.role === 'ophthalmologist') {
    return (
      <DashboardLayout title='Panel del Oftalmólogo'>
        <UserOption type='evaluations' />
        <UserOption type='case' />
      </DashboardLayout>
    )
  }

  if (user.role === 'patient') {
    return (
      <DashboardLayout title='Panel del Paciente'>
        <UserOption type='evaluations' />
        <UserOption type='case' />
      </DashboardLayout>
    )
  }

  if (user.role === 'admin') {
    return (
      <DashboardLayout title='Panel del Administrador' admin>
        <UserOption type='admin-institutions' />
        <UserOption type='admin-technicians' />
        <UserOption type='admin-ophthalmologists' />
        <UserOption type='admin-admins' />
        <UserOption type='admin-institution-admins' />
      </DashboardLayout>
    )
  }

  if (user.role === 'admin_institucion') {
    return (
      <DashboardLayout title='Panel Institucional' admin>
        <UserOption type='admin-technicians' />
        <UserOption type='admin-nodes' />
        <UserOption type='admin-ophthalmologists' />
      </DashboardLayout>
    )
  }

  return null
}

export default Home
